// Define interface for reminder data
export interface Reminder {
  id: string;
  title: string;
  description?: string;
  dueDateTime: string;
  priority: ReminderPriority;
  category?: string;
  completed: boolean;
  createdBy: string;
  publicVisible: boolean;
  location?: string;
  durationMinutes: number;
  createdAt: string;
  updatedAt: string;
}

// Define enum for reminder priority
export enum ReminderPriority {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
  URGENT = 'URGENT'
}

// Define interface for reminder form data
export interface ReminderFormData {
  title: string;
  description?: string;
  dueDateTime: string;
  priority: ReminderPriority;
  category?: string;
  completed: boolean;
  publicVisible: boolean;
  location?: string;
  durationMinutes: number;
}

// Define interface for calendar export data
export interface CalendarExportData {
  title: string;
  description?: string;
  startDateTime: string;
  endDateTime: string;
  location?: string;
}
